var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
var ExportJobLocation = /** @class */ (function (_super) {
    __extends(ExportJobLocation, _super);
    function ExportJobLocation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.city = null;
        _this.state = null;
        _this.country = null;
        _this.zipCode = null;
        return _this;
    }
    return ExportJobLocation;
}(Entity));
var ExportJob = /** @class */ (function (_super) {
    __extends(ExportJob, _super);
    function ExportJob() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.name = null;
        _this.remoteId = null;
        _this.location = new ExportJobLocation();
        // FE property for displaying the job in the UI
        _this.description = null;
        return _this;
    }
    ExportJob.prototype.fromJson = function (jsonData) {
        var _a;
        _super.prototype.fromJson.call(this, jsonData);
        this.description = ((_a = Object.values(this.location)) === null || _a === void 0 ? void 0 : _a.join(', ')) || '';
        return this;
    };
    __decorate([
        Type(ExportJobLocation),
        __metadata("design:type", ExportJobLocation)
    ], ExportJob.prototype, "location", void 0);
    return ExportJob;
}(Entity));
export { ExportJob };
